import { Component } from '@angular/core';

@Component({
  selector: 'ltg-recover-password-done',
  templateUrl: './recover-password-done.component.html',
  styleUrls: ['./recover-password-done.component.css']
})
export class RecoverPasswordDoneComponent { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/recover-password/recover-password-done/recover-password-done.component.ts